import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';

import starIcon from 'assets/img/icons/star.svg';
import helmetIcon from 'assets/img/icons/helmet.svg';
import cameraIcon from 'assets/img/icons/camera.svg';

import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as ProCreators } from 'store/ducks/pro';
import ProInfoCardHeader from './ProInfoCardHeader';
import PaymentInfoCard from './PaymentInfoCard';
import FavoriteCard from './FavoriteCard';

import AboutProModal from '../../OrderModals/AboutProModal';
import ServicePicProModal from '../../OrderModals/ServicesPicProModal';
import RatingsProModal from '../../OrderModals/RatingsProModal';

import {
  ProProfile,
  HeaderProfile,
  ProText,
  Boxes,
  ButtonBox,
  BtnIcon,
  InvalidatedText,
} from './styles.js';

const ProProfileColumn = ({
  taskDetail,
  taskQuoteProDetail,
  proProfile,
  proPortfolio,
  _authorizeTaskRequest,
  _getProProfile,
  _getProPortfolio,
  _getTaskDetail,
}) => {
  const [aboutModal, setAboutModal] = useState(false);
  const [servicePicModal, setServicePicModal] = useState(false);
  const [ratingModal, setRatingModal] = useState(false);

  const [validate, setValidate] = useState({
    rating: false,
    proProfile: false,
    proPortfolio: false,
    amount: false,
  });

  useEffect(() => {
    setValidate({
      ...validate,
      rating: proProfile.rating_list && proProfile.rating_list.length > 0,
      proProfile: proProfile.description,
      proPortfolio: proPortfolio && proPortfolio.length > 0,
      amount: taskQuoteProDetail && taskQuoteProDetail.price && taskQuoteProDetail.price > 0,
    });
  }, [proProfile, proPortfolio, taskQuoteProDetail]);

  const authorizeTaskRequest = async (data) => {
    _authorizeTaskRequest(data);
    await _getProPortfolio(data.userId);
    await _getProProfile(data.userId);
    await _getTaskDetail(taskDetail.id);
  };

  /* (taskQuoteProDetail && proProfile && */

  return (
    <ProProfile>
      <HeaderProfile />
      <ProInfoCardHeader proProfile={proProfile} />
      {taskQuoteProDetail.is_validated ? (
        <Fragment>
          <Boxes>
            <ButtonBox
              disabled={!validate.rating}
              onClick={() => (validate.rating ? setRatingModal(!ratingModal) : null)}
            >
              <BtnIcon src={starIcon} />
              <ProText>Ver todas avaliações</ProText>
            </ButtonBox>
            <ButtonBox
              disabled={!validate.proProfile}
              onClick={() => (validate.proProfile ? setAboutModal(!aboutModal) : null)}
            >
              <BtnIcon src={helmetIcon} />
              <ProText>Ler sobre o profissional</ProText>
            </ButtonBox>
            <ButtonBox
              disabled={!validate.proPortfolio}
              onClick={() => (validate.proPortfolio ? setServicePicModal(!servicePicModal) : null)}
            >
              <BtnIcon src={cameraIcon} />
              <ProText>Ver fotos de serviços</ProText>
            </ButtonBox>
          </Boxes>

          <PaymentInfoCard
            validate={validate}
            taskQuoteProDetail={taskQuoteProDetail}
            taskDetail={taskDetail}
            onFinish={authorizeTaskRequest}
          />

          {/* <FavoriteCard /> */}
        </Fragment>
      ) : (
        <InvalidatedText>
          <h5>PROFISSIONAL INDISPONÍVEL</h5>
          <p>
            Esse profissional não está mais na plataforma! Precisa de ajuda? Fale com o nosso
            atendimento.
          </p>
        </InvalidatedText>
      )}
      {validate.rating && (
        <RatingsProModal
          isOpen={ratingModal}
          toggle={() => setRatingModal(!ratingModal)}
          proRatings={proProfile.rating_list}
        />
      )}
      {validate.proProfile && (
        <AboutProModal
          isOpen={aboutModal}
          toggle={() => setAboutModal(!aboutModal)}
          proDescription={proProfile.description}
        />
      )}
      {validate.proPortfolio && (
        <ServicePicProModal
          isOpen={servicePicModal}
          toggle={() => setServicePicModal(!servicePicModal)}
          proPortfolio={proPortfolio}
        />
      )}
    </ProProfile>
    // )
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
  taskQuoteProDetail: state.task.taskQuoteProDetail,
  proProfile: state.pro.proProfile,
  proPortfolio: state.pro.proPortfolio,
});

const mapDispatchToProps = {
  _getTaskDetail: TaskCreators.getTaskDetailRequest,
  _authorizeTaskRequest: TaskCreators.authorizeTaskRequest,
  _getProProfile: ProCreators.getProProfileRequest,
  _getProPortfolio: ProCreators.getProPortfolioRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProProfileColumn);
